export default __webpack_public_path__ + "static/media/me.8f00df1a.svg";